const optionKeys = ['eventType', 'eventSource'];

/** Creates an object from analytics options passed in to allow for easy access */
export default (options) => {
    if (!options?.length) return null;
    return options.reduce((optionMap, currentValue) => {
        const keys = Object.keys(currentValue).filter((k) =>
            optionKeys.includes(k)
        );

        const newOptionMap = { ...optionMap };
        keys.forEach((k) => {
            newOptionMap[k] = currentValue[k];
        });
        return newOptionMap;
    }, {});
};
